export default "__VITE_ASSET__55c0a495__"